export default __webpack_public_path__ + "static/media/lottery-hover.71a0e303.webp";